import { useTranslator } from "@eo-locale/react";
import { useEffect, useState } from "react";

import SelectFilter from "./select-filter";
import { useAppSelector } from "@/redux/store/hooks";

const StateFilter = (): JSX.Element => {
  const { translate } = useTranslator();
  const { finder } = useAppSelector((state) => state.projects);
  const { queryFilter } = useAppSelector((state) => state.projectFinder);
  const { locales } = queryFilter;

  const [selection, setSelection] = useState("");

  useEffect((): void => {
    setSelection(finder.state);
  }, [finder]);

  const selectedValue = selection
    ? {
        value: selection,
        label:
          selection === "published"
            ? locales["projects.states.published"] ||
              translate("projectFinder.states.published")
            : locales["projects.states.archived"] ||
              translate("projectFinder.states.archived")
      }
    : null;

  const states: { value: string; label: string }[] = [
    {
      value: "published",
      label:
        locales["projects.states.published"] ||
        translate("projectFinder.states.published")
    },
    {
      value: "archived",
      label:
        locales["projects.states.archived"] ||
        translate("projectFinder.states.archived")
    }
  ];

  return (
    <SelectFilter
      options={states}
      label={
        locales["projects.states.all"] || translate("projectFinder.states.all")
      }
      type="state"
      selectedValue={selectedValue}
      boxClass="ehq-projectsStateFilterContainer"
    />
  );
};

export default StateFilter;
